import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../Table";
import { ListarApontamentoDeHorasController } from "../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IApontamentoHoras } from "../../../Interfaces/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasInterfaces";
import RegistrarApontamentoHoras from "../../../Pages/AssistenciaTecnica/Atendimento/RegistrarApontamentoHoras";
import SpinnerComponent from "../../Loding/Spinner";
import ModalComponent from "../../Modais";
import { IComponentModal } from "../../Modais/IModalComponent";
import LeiaMais from "../../Utils/LeiaMais";
import { ETAPA_ASSISTENCIA_TECNICA } from "../../../Constants/AssistenciaTecnica/EtapaTipoCaso";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";

interface IApontamentoHorasProps {
    Atendimento: IAtendimentoExtraDetalhado;
}

export default function ApontamentoHoras(props: IApontamentoHorasProps) {
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    const {
        value: lstApontamentoHoras,
        loading: lstApontamentoHorasLoading,
        execute,
    } = useAsyncEffect(async () => {
        return ListarApontamentoDeHorasController(props.Atendimento.ID_CASO);
    }, [props.Atendimento.ID_CASO]);

    const tableviewColumns: Array<ColumnDescription<IApontamentoHoras>> = [
        {
            dataField: "DS_ASSUNTO",
            text: "Assunto",
        },
        {
            dataField: "DT_ACAO",
            text: "Data",
            formatter: (c) => (c ? new Date(c).toLocaleString() : "-"),
        },
        {
            dataField: "DS_NOME",
            text: "Atribuido à",
        },
        {
            dataField: "DS_TIPO_AGENDAMENTO",
            text: "Tipo de Agendamento",
        },
        {
            dataField: "DS_STATUS",
            text: "Status",
        },
        {
            dataField: "DS_DURACAO",
            text: "Duração Real",
        },
        {
            dataField: "DS_OBSERVACAO",
            text: "Descrição",
            formatter: (observacao: string) => (
                <LeiaMais charLimit={40}>{observacao}</LeiaMais>
            ),
        },
    ];

    return (
        <div className="card card-custom">
            {
                <>
                    {lstApontamentoHoras ? (
                        <>
                            <div className="d-flex justify-content-end">
                                {[
                                    ETAPA_ASSISTENCIA_TECNICA
                                        .AGENDAMENTO_VISTORIA_INICIAL.NR_ETAPA,
                                    ETAPA_ASSISTENCIA_TECNICA
                                        .EXECUCAO_VISTORIA_INICIAL.NR_ETAPA,
                                    ETAPA_ASSISTENCIA_TECNICA.AGENDAR_MANUTENCAO
                                        .NR_ETAPA,
                                    ETAPA_ASSISTENCIA_TECNICA
                                        .EXECUCAO_DE_MANUTENCAO.NR_ETAPA,
                                    ETAPA_ASSISTENCIA_TECNICA
                                        .PESQUISA_SATISFACAO.NR_ETAPA,
                                ].some(
                                    (etapa) =>
                                        etapa === props.Atendimento.NR_ETAPA
                                ) && (
                                    <button
                                        className="btn btn-success d-flex align-items-center justify-content-center flex-nowrap ml-3 mr-3 g-2 m-3"
                                        onClick={() => {
                                            setShow(true);
                                            setModal({
                                                headerComponent:
                                                    "Registrar Apontamento de Horas",
                                                IconHeader: faPlus,
                                                Component: () => (
                                                    <RegistrarApontamentoHoras
                                                        updateList={execute}
                                                        setShow={setShow}
                                                        idTipoCaso={
                                                            props.Atendimento
                                                                .ID_TIPO_CASO
                                                        }
                                                    />
                                                ),
                                            });
                                        }}
                                    >
                                        Registrar Apontamento de Horas
                                        <span>
                                            <FontAwesomeIcon icon={faPlus} />
                                        </span>
                                    </button>
                                )}
                            </div>
                            <Table
                                columns={tableviewColumns}
                                data={lstApontamentoHoras}
                                keyField="ID_CASO"
                                loading={lstApontamentoHorasLoading}
                                noDataIndication={() => (
                                    <div className="text-black-50 text-center">
                                        Nenhum Registro de Hora Encontrado
                                    </div>
                                )}
                                noHover
                                noSearch
                                bordered={false}
                                defaultStyle={{
                                    align: "center",
                                    classes: "p-2",
                                }}
                                striped={true}
                                rowClasses={"rowClasses"}
                            />
                        </>
                    ) : (
                        <SpinnerComponent />
                    )}
                </>
            }
            <ModalComponent
                setShow={setShow}
                show={show}
                ModalComponent={modal}
            />
        </div>
    );
}
